import { usarPermissionamento } from "@/composable/UsarPermissionamento"
import { OperacaoDePermissionamento } from "@/composable/UsarPermissionamento/modulosDePermissao"
import {
  ComposableDePermissionamento,
  NomeModuloTimesheet,
  RecursoDePermissionamento,
} from "@/composable/UsarPermissionamento/usarPermissionamento"
import { VNode } from "vue"

type TratamentoDePermissionamento = "remover" | "ocultar" | "desabilitar"

type ModificadoresDePermissao = {
  intriseca?: boolean
}

type OpcoesDiretivaDePermissionamento = {
  operacao: OperacaoDePermissionamento
  recurso?: RecursoDePermissionamento
  tratamento?: TratamentoDePermissionamento
}

const verificarPermissaoUsandoComposable = (
  permissionador: ComposableDePermissionamento,
  modificadores: ModificadoresDePermissao,
  opcoesDaDiretiva: OpcoesDiretivaDePermissionamento
) => {
  const { operacao, recurso } = opcoesDaDiretiva
  if (modificadores.intriseca) {
    return permissionador.verificarPermissaoIntrinseca(
      operacao,
      recurso as RecursoDePermissionamento
    )
  }
  return permissionador.verificarPermissao(operacao)
}

const realizarTratamentoConformePermissao = (
  possuiPermissao: boolean,
  noduloVirtual: VNode,
  tratamento: TratamentoDePermissionamento = "remover"
) => {
  if (possuiPermissao) {
    return
  }

  const selecionarTratativaParaElemento = () => {
    const elementoDoNodulo = noduloVirtual.el
    if (!elementoDoNodulo) {
      return
    }
    const funcaoDeTratamento = {
      remover: () =>
        elementoDoNodulo.parentElement?.removeChild(noduloVirtual.el),
      ocultar: () => (elementoDoNodulo.style.display = "none"),
      desabilitar: () => (elementoDoNodulo.disabled = true),
    }[tratamento]

    funcaoDeTratamento()
  }

  selecionarTratativaParaElemento()
}

export default {
  mounted(elemento: HTMLElement, { value, modifiers, arg }, noduloVirtual) {
    const modulo: NomeModuloTimesheet = arg
    const modificadores: ModificadoresDePermissao = modifiers
    const opcoesDaDiretiva: OpcoesDiretivaDePermissionamento = value

    const permissionador = usarPermissionamento(modulo)
    const possuiPermissao = verificarPermissaoUsandoComposable(
      permissionador,
      modificadores,
      opcoesDaDiretiva
    )
    realizarTratamentoConformePermissao(
      possuiPermissao,
      noduloVirtual,
      opcoesDaDiretiva.tratamento
    )
  },
}
